module.exports = __webpack_public_path__ + "static/img/bgscimg5moxin4.23e7076.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rppghealth/bgscimg5moxin4.png
// module id = UTyr
// module chunks = 5